import EmptyCard from "app/storybookComponents/Cards/EmptyCard";

interface Props {
  isLoading: boolean;
  totalDataCount: number;
  filteredCount: number;
  noDataTitle: string;
  noDataBody: string;
  entitySelected: string;
  searchInput: string;
}

export default function TableEmptyState({
  isLoading,
  totalDataCount,
  filteredCount,
  noDataTitle,
  noDataBody,
  entitySelected,
  searchInput,
}: Readonly<Props>) {
  if (isLoading) return null;

  if (totalDataCount === 0) {
    return <EmptyCard title={noDataTitle} bodyText={noDataBody} />;
  }

  if (filteredCount === 0) {
    return (
      <EmptyCard
        title={`No ${entitySelected} found matching "${searchInput}"`}
        bodyText="Try searching for a different name."
      />
    );
  }

  return null;
}
